/** @jsxRuntime classic */
/** @jsx jsx */
import ExhibitorProductListPage from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorPage/ExhibitorProductListPage';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout/Layout';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function ExhibitorSidebar(props) {
  const { exhibitor } = afterQuery(props?.data);
  // console.log('vv2_exhibitor', exhibitor, props);
  return (
    <Layout>
      <ExhibitorProductListPage exhibitor={exhibitor} />
    </Layout>
  );
}

export const pageQuery = graphql`
  query vv_ExhibitorProducts(
    $partnerId: ID!
    $collectionId: ID!
    $locale: Bottlebooks_ContentLocale
  ) {
    exhibitor(exhibitorId: { eq: $partnerId }) {
      ...ExhibitorProductListPage
    }
    bottlebooks {
      collection(collectionId: $collectionId, locale: $locale) {
        collectionId
        registrations(filter: { companyId: { eq: $partnerId } }) {
          nodes {
            ... on Bottlebooks_SingleRegistration {
              registeredProducts {
                nodes {
                  productId
                  product {
                    ...vv_ProductName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

function afterQuery(data) {
  const registeredProducts =
    data?.bottlebooks?.collection?.registrations?.nodes?.[0]?.registeredProducts
      ?.nodes;
  const exhibitor = {
    ...data?.exhibitor,
    products: data?.exhibitor?.products?.map((product) => {
      const registeredProduct = registeredProducts?.find(
        (registeredProduct) => registeredProduct.productId === product.productId
      );
      return {
        ...product,
        ...registeredProduct,
        ...registeredProduct?.product,
      };
    }),
  };
  return {
    exhibitor,
  };
}
